"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionCreator = sessionCreator;
exports.brandConfigRetriever = brandConfigRetriever;
exports.faceplateGroupsWatcher = faceplateGroupsWatcher;
exports.initialPaymentConfigDataRequestWatcher = initialPaymentConfigDataRequestWatcher;
exports.orderPlacementRequestWatcher = orderPlacementRequestWatcher;
exports.createCapiSaga = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _actions = require("./actions");

var _requests = require("../requests");

var _marked =
/*#__PURE__*/
_regenerator.default.mark(sessionCreator),
    _marked2 =
/*#__PURE__*/
_regenerator.default.mark(brandConfigRetriever),
    _marked3 =
/*#__PURE__*/
_regenerator.default.mark(faceplateGroupsWatcher),
    _marked4 =
/*#__PURE__*/
_regenerator.default.mark(initialPaymentConfigDataRequestWatcher),
    _marked5 =
/*#__PURE__*/
_regenerator.default.mark(orderPlacementRequestWatcher);

/**
 * This saga manages communicating with CAPI V4 via redux actions.
 *
 * Calling applications can dispatch an action associated with some CAPI functionality,
 * and their reducers can react to the responses generated by this saga.
 *
 * @param {function} clientSelector - A selector function accepting the redux state object
 *      which will return an axios client configured to query CAPI. See requests.createCapiClient
 *      for an example of creating a client.
 * @param {function} sessionIdSelector - A selector function accepting the redux state
 *      object which will return any current CAPI session ID, or a falsy value otherwise.
 * @return {saga} A generator function that can be fed into redux-saga's middleware.run()
 */
var createCapiSaga = function createCapiSaga(clientSelector, sessionIdSelector) {
  var saga =
  /*#__PURE__*/
  _regenerator.default.mark(function capiSaga() {
    return _regenerator.default.wrap(function capiSaga$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _effects.spawn)(sessionCreator, clientSelector, sessionIdSelector);

          case 2:
            _context.next = 4;
            return (0, _effects.spawn)(brandConfigRetriever, clientSelector);

          case 4:
            _context.next = 6;
            return (0, _effects.spawn)(orderPlacementRequestWatcher, clientSelector);

          case 6:
            _context.next = 8;
            return (0, _effects.spawn)(faceplateGroupsWatcher, clientSelector);

          case 8:
            _context.next = 10;
            return (0, _effects.spawn)(initialPaymentConfigDataRequestWatcher, clientSelector);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, capiSaga);
  });

  return saga;
};
/**
 * This saga handles creating new CAPI sessions for order placement.
 *
 * CAPI sessions are lightweight and not essential to the order placement
 * flow, but provide a way to handle tracking state across requests to CAPI
 * as well as collecting very basic analytics on a user's visit.
 *
 * @param {function} clientSelector - A selector function accepting the redux state object
 *      which will return an axios client configured to query CAPI. See requests.createCapiClient
 *      for an example of creating a client.
 * @param {function} sessionIdSelector - A selector function accepting the redux state
 *      object which will return any current CAPI session ID, or a falsy value otherwise.
 */


exports.createCapiSaga = createCapiSaga;

function sessionCreator(clientSelector, sessionIdSelector) {
  var _ref, data, existingId, capiClient, session;

  return _regenerator.default.wrap(function sessionCreator$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 28;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_actions.CREATE_CAPI_SESSION);

        case 3:
          _ref = _context2.sent;
          data = _ref.data;
          _context2.next = 7;
          return (0, _effects.select)(sessionIdSelector);

        case 7:
          existingId = _context2.sent;

          if (!existingId) {
            _context2.next = 10;
            break;
          }

          return _context2.abrupt("return");

        case 10:
          _context2.next = 12;
          return (0, _effects.select)(clientSelector);

        case 12:
          capiClient = _context2.sent;

          if (!capiClient) {
            _context2.next = 26;
            break;
          }

          session = {};
          _context2.prev = 15;
          _context2.next = 18;
          return (0, _effects.call)(_requests.createNewSession, capiClient, data);

        case 18:
          session = _context2.sent;
          _context2.next = 24;
          break;

        case 21:
          _context2.prev = 21;
          _context2.t0 = _context2["catch"](15);
          return _context2.abrupt("return");

        case 24:
          _context2.next = 26;
          return (0, _effects.put)((0, _actions.setCapiSession)(session.sessionId));

        case 26:
          _context2.next = 0;
          break;

        case 28:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, null, [[15, 21]]);
}
/**
 * This saga handles retrieving a Brand's configuration from the v4/config endpoint.
 *
 * Repeated requests for config will kill off earlier requests that have not finished,
 * so that only the most recent request will result in an action being dispatched.
 * If a caller needs to request multiple parts of the Brand's config simultaneously,
 * it should request them all at once rather than piecemeal.
 *
 * @param {function} clientSelector - A selector function accepting the redux state object
 *      which will return an axios client configured to query CAPI. See requests.createCapiClient
 *      for an example of creating a client.
 */


function brandConfigRetriever(clientSelector) {
  return _regenerator.default.wrap(function brandConfigRetriever$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)(_actions.FETCH_BRAND_CONFIG,
          /*#__PURE__*/
          _regenerator.default.mark(function innerRetriever(action) {
            var fields, capiClient, retrievedConfig, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, field, data;

            return _regenerator.default.wrap(function innerRetriever$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    // We assume fields are always included, as per `fetchBrandConfig`
                    fields = action.fields;
                    _context3.next = 3;
                    return (0, _effects.select)(clientSelector);

                  case 3:
                    capiClient = _context3.sent;
                    retrievedConfig = {};
                    _context3.prev = 5;
                    _context3.next = 8;
                    return (0, _effects.call)(_requests.getBrandConfig, capiClient, fields);

                  case 8:
                    retrievedConfig = _context3.sent;
                    _context3.next = 16;
                    break;

                  case 11:
                    _context3.prev = 11;
                    _context3.t0 = _context3["catch"](5);
                    _context3.next = 15;
                    return (0, _effects.put)((0, _actions.fetchBrandConfigError)(_context3.t0));

                  case 15:
                    return _context3.abrupt("return");

                  case 16:
                    // for-of statement is necessary because we cannot yield from a forEach callback
                    // eslint-disable-next-line no-restricted-syntax
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context3.prev = 19;
                    _iterator = fields[Symbol.iterator]();

                  case 21:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                      _context3.next = 34;
                      break;
                    }

                    field = _step.value;
                    data = retrievedConfig[field];

                    if (!data) {
                      _context3.next = 29;
                      break;
                    }

                    _context3.next = 27;
                    return (0, _effects.put)(_actions.retrievedBrandConfigActions[field](data));

                  case 27:
                    _context3.next = 31;
                    break;

                  case 29:
                    _context3.next = 31;
                    return (0, _effects.put)((0, _actions.fetchBrandConfigError)("No ".concat(field, " configuration data returned")));

                  case 31:
                    _iteratorNormalCompletion = true;
                    _context3.next = 21;
                    break;

                  case 34:
                    _context3.next = 40;
                    break;

                  case 36:
                    _context3.prev = 36;
                    _context3.t1 = _context3["catch"](19);
                    _didIteratorError = true;
                    _iteratorError = _context3.t1;

                  case 40:
                    _context3.prev = 40;
                    _context3.prev = 41;

                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return();
                    }

                  case 43:
                    _context3.prev = 43;

                    if (!_didIteratorError) {
                      _context3.next = 46;
                      break;
                    }

                    throw _iteratorError;

                  case 46:
                    return _context3.finish(43);

                  case 47:
                    return _context3.finish(40);

                  case 48:
                  case "end":
                    return _context3.stop();
                }
              }
            }, innerRetriever, null, [[5, 11], [19, 36, 40, 48], [41,, 43, 47]]);
          }));

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked2);
}
/**
 * Watcher for the requestFaceplateGroups saga.
 *
 * @param {function} clientSelector - A selector function accepting the redux state object
 *      which will return an axios client configured to query CAPI. See requests.createCapiClient
 *      for an example of creating a client.
 */


function faceplateGroupsWatcher(clientSelector) {
  return _regenerator.default.wrap(function faceplateGroupsWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_actions.FETCH_FACEPLATE_GROUPS,
          /*#__PURE__*/
          _regenerator.default.mark(function requestFaceplateGroups(action) {
            var params, capiClient, returnedGroups;
            return _regenerator.default.wrap(function requestFaceplateGroups$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    params = action.params;
                    _context5.next = 3;
                    return (0, _effects.select)(clientSelector);

                  case 3:
                    capiClient = _context5.sent;
                    _context5.prev = 4;
                    _context5.next = 7;
                    return (0, _effects.call)(_requests.getFaceplates, capiClient, params);

                  case 7:
                    returnedGroups = _context5.sent;
                    _context5.next = 10;
                    return (0, _effects.put)((0, _actions.retrievedFaceplateGroups)(returnedGroups));

                  case 10:
                    _context5.next = 16;
                    break;

                  case 12:
                    _context5.prev = 12;
                    _context5.t0 = _context5["catch"](4);
                    _context5.next = 16;
                    return (0, _effects.put)((0, _actions.fetchFaceplateGroupsError)(_context5.t0));

                  case 16:
                  case "end":
                    return _context5.stop();
                }
              }
            }, requestFaceplateGroups, null, [[4, 12]]);
          }));

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked3);
}
/**
 * Watcher for the requestInitialPaymentConfigData saga.
 *
 * @param {function} clientSelector - A selector function accepting the redux state object
 *      which will return an axios client configured to query CAPI. See requests.createCapiClient
 *      for an example of creating a client.
 */


function initialPaymentConfigDataRequestWatcher(clientSelector) {
  return _regenerator.default.wrap(function initialPaymentConfigDataRequestWatcher$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)(_actions.GET_INITIAL_PAYMENT_CONFIG_DATA,
          /*#__PURE__*/
          _regenerator.default.mark(function requestInitialPaymentConfigData(action) {
            var data, capiClient, initiateConfigResult;
            return _regenerator.default.wrap(function requestInitialPaymentConfigData$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    data = action.data;
                    _context7.next = 3;
                    return (0, _effects.select)(clientSelector);

                  case 3:
                    capiClient = _context7.sent;
                    _context7.prev = 4;
                    _context7.next = 7;
                    return (0, _effects.call)(_requests.getInitialPaymentConfigData, capiClient, data);

                  case 7:
                    initiateConfigResult = _context7.sent;
                    _context7.next = 10;
                    return (0, _effects.put)((0, _actions.retrievedInitiateConfigData)(initiateConfigResult));

                  case 10:
                    if (!initiateConfigResult.sessionId) {
                      _context7.next = 13;
                      break;
                    }

                    _context7.next = 13;
                    return (0, _effects.put)((0, _actions.setCapiSession)(initiateConfigResult.sessionId));

                  case 13:
                    _context7.next = 19;
                    break;

                  case 15:
                    _context7.prev = 15;
                    _context7.t0 = _context7["catch"](4);
                    _context7.next = 19;
                    return (0, _effects.put)((0, _actions.initiateConfigRequestFailed)(_context7.t0));

                  case 19:
                  case "end":
                    return _context7.stop();
                }
              }
            }, requestInitialPaymentConfigData, null, [[4, 15]]);
          }));

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked4);
}
/**
 * This saga handles placing orders, accepting payment and returning the resulting order
 * or errors if they occur.
 *
 * @param {function} clientSelector - A selector function accepting the redux state object
 *      which will return an axios client configured to query CAPI. See requests.createCapiClient
 *      for an example of creating a client.
 */


function orderPlacementRequestWatcher(clientSelector) {
  var _ref2, order, capiUriVersion, capiClient, sendOrderService, orderResult;

  return _regenerator.default.wrap(function orderPlacementRequestWatcher$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (!true) {
            _context9.next = 25;
            break;
          }

          _context9.next = 3;
          return (0, _effects.take)(_actions.PLACE_ORDER);

        case 3:
          _ref2 = _context9.sent;
          order = _ref2.order;
          capiUriVersion = order.CAPI_URI_VERSION;
          _context9.next = 8;
          return (0, _effects.select)(clientSelector);

        case 8:
          capiClient = _context9.sent;
          _context9.prev = 9;
          sendOrderService = _requests.sendOrder;

          if (capiUriVersion && capiUriVersion === 'v5') {
            sendOrderService = _requests.sendOrderV5;
          }

          _context9.next = 14;
          return (0, _effects.call)(sendOrderService, capiClient, order);

        case 14:
          orderResult = _context9.sent;
          _context9.next = 17;
          return (0, _effects.put)((0, _actions.orderSucceeded)(orderResult));

        case 17:
          _context9.next = 23;
          break;

        case 19:
          _context9.prev = 19;
          _context9.t0 = _context9["catch"](9);
          _context9.next = 23;
          return (0, _effects.put)((0, _actions.orderFailed)(_context9.t0));

        case 23:
          _context9.next = 0;
          break;

        case 25:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked5, null, [[9, 19]]);
}